import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatMenuModule } from '@angular/material/menu';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from "@angular/material";
import { CoreComponentsModule } from '@app/core/components/core-components.module';
import { ComponentsModule } from '@app/features/components/components.module';
import { SharedModule } from '@app/shared/shared.module';
import { TextMaskModule } from 'angular2-text-mask';
import { MasterClienteCreateUserComponent } from './cliente-criar-usuario-stepper/master-cliente-create-user.component';
import { MasterClienteEditarUsuarioComponent } from './cliente-editar-usuario/cliente-editar-usuario.component';
import { ClienteGrupoInvestimentoComponent } from './cliente-grupo-investimento/cliente-grupo-investimento.component';
import { ClienteTablePerfilAcesso } from './cliente-perfil-acesso/cliente-table-perfil-acesso/cliente-table-perfil-acesso.component';
import { AppTableClienteCreateProfile } from './cliente-perfil-acesso/master-cliente-create-profile/custom-components/table-create-profile/table-cliente-create-profile.component';
import { MasterClienteHomeCreateProfileComponent } from './cliente-perfil-acesso/master-cliente-create-profile/master-cliente-home-create-profile.component';
import { MasterClienteCreateProfileComponent } from './cliente-perfil-acesso/master-cliente-create-profile/views/permissoes/master-cliente-create-profile.component';
import { MasterClientePerfilAcessoComponent } from './cliente-perfil-acesso/master-cliente-perfil-acesso.component';
import { MasterClienteVisualizarUsuarioComponent } from './cliente-visualizar-usuario/cliente-visualizar-usuario.component';

@NgModule({
  declarations: [
    MasterClienteCreateUserComponent,
    MasterClienteEditarUsuarioComponent,
    ClienteGrupoInvestimentoComponent,
    MasterClientePerfilAcessoComponent,
    ClienteTablePerfilAcesso,
    AppTableClienteCreateProfile,
    MasterClienteHomeCreateProfileComponent,
    MasterClienteCreateProfileComponent,
    MasterClienteVisualizarUsuarioComponent
  ],
  entryComponents: [
    MasterClienteCreateUserComponent,
    MasterClienteEditarUsuarioComponent,
    ClienteGrupoInvestimentoComponent,
    MasterClientePerfilAcessoComponent,
    MasterClienteHomeCreateProfileComponent,
    MasterClienteVisualizarUsuarioComponent
  ],
  imports: [
    MatPaginatorModule,
    CommonModule,
    SharedModule,
    CoreComponentsModule,
    ComponentsModule,
    FormsModule,
    MatFormFieldModule,
    TextMaskModule,
    ReactiveFormsModule,
    MatStepperModule,
    MatExpansionModule,
    MatTableModule,
    MatSortModule,
    MatMenuModule,
    MatAutocompleteModule
  ],
  exports: [
    MatAutocompleteModule
  ]
})
export class ClienteModule { }
